import apiUserInfo from '../api/userInfo'
import apiAuth from '../api/auth'
import useAuthStore from '../../stores/authStore'
import { useCapabilitiesStore } from '../../stores/capabilitiesStore'
import { beginIntentionalLogout, clearStoredSessionState } from './forceLogout'

/**
 * Session orchestration for v2 auth. The access token is an httpOnly cookie set
 * by the backend; the client never holds it. A "session" on the client is the
 * identity (from /v2/auth/user-info) plus the capabilities snapshot.
 */

export async function startSession() {
  const info = await apiUserInfo.get()
  useAuthStore.getState().hydrateFromUserInfo(info)
  const capabilities = useCapabilitiesStore.getState()
  capabilities.reset()
  await capabilities.ensureLoaded()
}

export async function endSession() {
  // Flag it before the request: logging out clears the token server-side, so
  // anything still in flight 401s, and those must not surface as "session expired".
  beginIntentionalLogout()
  try {
    await apiAuth.logout()
  } finally {
    useAuthStore.getState().clear()
    useCapabilitiesStore.getState().reset()
    clearStoredSessionState()
  }
}
